import { useState } from "react";
import { Loader2, Send } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Reveal, SectionLabel } from "./Reveal";

const KINDS = [
  { id: "birthday", label: "Birthday" },
  { id: "corporate", label: "Corporate" },
  { id: "franchise", label: "Franchise" },
  { id: "general", label: "General" },
];
const EMPTY = { name: "", phone: "", email: "", city: "", guests: "", event_date: "", message: "" };

export const Enquiry = ({ kind, setKind }) => {
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const body = { kind, ...f, email: f.email || null, guests: f.guests ? Number(f.guests) : null, event_date: f.event_date || null };
      await api.post("/enquiries", body);
      toast.success("Thanks! Our team will get in touch shortly.");
      setF(EMPTY);
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };

  return (
    <section id="enquire" data-testid="enquiry-section" className="relative py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 grid lg:grid-cols-12 gap-12">
        <Reveal className="lg:col-span-5">
          <SectionLabel color="text-[#FFEF00]">Let's talk</SectionLabel>
          <h2 className="font-display font-black uppercase text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">Got a big<br /><span className="text-[#14C3F7]">plan?</span></h2>
          <p className="mt-6 text-slate-300 max-w-md">Birthdays, corporate events, group bookings or bringing a ZoopUp franchise to your city — drop your details and we'll call you back.</p>
        </Reveal>
        <Reveal className="lg:col-span-7" delay={0.1}>
          <form onSubmit={submit} data-testid="enquiry-form" className="rounded-[28px] bg-[#0E101D] border border-white/10 p-6 md:p-9">
            <div className="flex flex-wrap gap-2 mb-7">
              {KINDS.map((k) => (
                <button type="button" key={k.id} data-testid={`enquiry-kind-${k.id}`} onClick={() => setKind(k.id)}
                  className={`rounded-full px-5 py-2.5 text-sm font-semibold border-2 transition-colors ${kind === k.id ? "bg-[#FFEF00] text-black border-black" : "border-white/15 hover:border-[#FFEF00]"}`}>{k.label}</button>
              ))}
            </div>
            <div className="grid sm:grid-cols-2 gap-4">
              <input data-testid="enquiry-name-input" className="field" placeholder="Full name" value={f.name} onChange={set("name")} required minLength={2} />
              <input data-testid="enquiry-phone-input" className="field" placeholder="Phone" value={f.phone} onChange={set("phone")} required minLength={7} />
              <input data-testid="enquiry-email-input" type="email" className="field" placeholder="Email (optional)" value={f.email} onChange={set("email")} />
              <input data-testid="enquiry-city-input" className="field" placeholder="City" value={f.city} onChange={set("city")} />
              {kind !== "franchise" && <input data-testid="enquiry-guests-input" type="number" min="1" className="field" placeholder="No. of guests" value={f.guests} onChange={set("guests")} />}
              {kind !== "franchise" && <input data-testid="enquiry-date-input" type="date" className="field" value={f.event_date} onChange={set("event_date")} />}
            </div>
            <textarea data-testid="enquiry-message-input" rows={4} className="field mt-4 resize-none" placeholder="Tell us more" value={f.message} onChange={set("message")} data-lenis-prevent />
            <button data-testid="enquiry-submit-btn" disabled={busy} className="btn-zoop mt-7 rounded-full px-8 py-4 font-display font-bold inline-flex items-center gap-2 disabled:opacity-60">
              {busy ? <Loader2 className="animate-spin" size={18} /> : <Send size={18} />} Send enquiry
            </button>
          </form>
        </Reveal>
      </div>
    </section>
  );
};
